/* eslint-disable array-callback-return */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import { Flex, Spacer } from "@chakra-ui/react";
import { RadioBtn } from "components/ComponentRadioButton/RadioBtn";
import InputSelect from "components/InputSelect/InputSelect";
import FormCrudCRUDContext from "context/FormCrudContex";
import GlobalContext from "context/GlobalContext";
import { useForm } from "hooks/useForm";
import { useSearchUrl } from "hooks/useSearchUrl";
import { formExpiredSortBy } from "pages/Pass-Form/View/BusquedaAvanzada/ArraySelect";
import { LabelGroup } from "pages/RefProductInter/LabelGroup";
import React, { useContext, useState } from "react";
import { ButtonStyled } from "styled/Buttons.styled";
import { handleSanitizedObj } from "utils/type-check-utils";

const FormExitVencimientos = ({
  onClose,
}) => {
  const { currentSearch, setParamsSearch } = useSearchUrl({ nestedProp: "searchAdvance" });

  const [values, handleInputChange, reset] = useForm({
    code_outputForm: currentSearch?.code_outputForm,
    dta: currentSearch?.dta,
    date_initial: currentSearch?.date_initial,
    date_final: currentSearch?.date_final,
  });

  const { code_outputForm, date_initial, date_final } = values;

  const options = ["Ascendente", "Descendente"];

  const [selectAD, setSelectAD] = useState(currentSearch?.orderby_type === 'ASC' ? 'Ascendente' : 'Descendente');
  const [sortBy, setSortBy] = useState(currentSearch?.sortBy);

  const handleBusqueda = () => {
    const newObjetData = {
      ...values,
      ...(sortBy && sortBy?.value && { orderby: sortBy?.value }),
      orderby_type: selectAD === "Ascendente" ? "ASC" : "DESC"
    };

    setParamsSearch({ params: handleSanitizedObj({ ...newObjetData, sortBy, typeSearch: "EXPIRED" }) });
    onClose();
  };

  return (
    <>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginBottom: "2rem"
        }}
      >
        <LabelGroup
          name={"code_outputForm"}
          value={code_outputForm}
          onChange={handleInputChange}
          tag={"Nº Formulario"}
          size={45}
          tipo={"text"}
        />
        <div style={{ width: `45%` }}>
          <InputSelect
            name={"sortBy"}
            tag={"Ordenar por:"}
            data={formExpiredSortBy}
            value={sortBy}
            set={setSortBy}
          />
        </div>
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginBottom: "2rem"
        }}
      >
        <LabelGroup
          name={"date_initial"}
          value={date_initial}
          onChange={handleInputChange}
          tag={"Fecha Inic. Venc. Plz"}
          size={45}
          tipo={"date"}
        />
        <LabelGroup
          name={"date_final"}
          value={date_final}
          onChange={handleInputChange}
          tag={"Fecha Final Venc. Plz"}
          size={45}
          tipo={"date"}
        />
      </div>

      {/* <div className="margin-search"> */}
      <RadioBtn options={options} setOnly={setSelectAD} state={selectAD} />
      {/* </div> */}
      <Flex className="my-3">
        <ButtonStyled bgColor={"#bababa"} onClick={onClose}>
          Cerrar
        </ButtonStyled>
        <Spacer />
        <ButtonStyled
          bgColor={"#03C39A"}
          type="submit"
          onClick={() => handleBusqueda()}
        >
          Buscar
        </ButtonStyled>
      </Flex>
    </>
  );
};

export default FormExitVencimientos;
